import React, { useMemo } from 'react'

import { usePlannerContext } from '@/context'
import { PlannerItemResponse } from '@/types/Planner'
import { formatDate, getPlannerTime } from '@/util'
import { getPlannerItemTitle } from '@/util/PlannerUtil'

import Badge from '../Badge'
import { getWeeklyList } from './ListView.data'

type Props = {
  data: PlannerItemResponse[] | undefined
  onEventClick: (event: PlannerItemResponse) => void
}

export const ListView = ({ data, onEventClick }: Props) => {
  const { startWeekDate, endWeekDate } = usePlannerContext()

  const startDate = formatDate(startWeekDate, 'MMM dd')
  const endDate = formatDate(endWeekDate, 'MMM dd')

  const weeklyList = useMemo(() => getWeeklyList(startWeekDate, endWeekDate, data), [startWeekDate, endWeekDate, data])

  return (
    <div className="px-4">
      <div className="mt-4 flex w-full">
        <h2>
          {startDate} - {endDate}
        </h2>
      </div>
      <div className="mt-4 flex w-full flex-col">
        {weeklyList &&
          weeklyList.map((day, index) => {
            const { tasks } = day
            return (
              <div className="flex w-full" key={index}>
                <div className="flex flex-col py-6 pr-2">
                  <p className="text-3xl leading-120">{day.date}</p>
                  <p className="text-p-sm leading-none text-icon-secondary">{day.month}</p>
                  <p className="text-p-xs text-tertiary">{day.day}</p>
                </div>
                <div className="flex w-full flex-col border-b py-6 border-secondary">
                  {tasks.map((task, _index) => {
                    return (
                      <div
                        className={`flex w-full flex-col items-start rounded-md border border-grey-200 px-6 py-4 ${
                          _index === 0 ? '' : 'mt-4'
                        }`}
                        key={_index}
                        onClick={() => {
                          onEventClick(task)
                        }}
                        role="presentation"
                      >
                        {task.startTime && task.endTime ? (
                          <p className="mb-1 text-tertiary">
                            {getPlannerTime(task.startTime, 'h:mmaaa')} - {getPlannerTime(task.endTime)}
                          </p>
                        ) : !task?.isScheduled ? (
                          <p className="mb-1 text-red-200" style={{ fontWeight: 700 }}>
                            Unscheduled
                          </p>
                        ) : null}
                        <p className="mb-2 capitalize leading-180">{getPlannerItemTitle(task)}</p>
                        <Badge item={task} />
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}
